
import React, {Fragment} from 'react';
import styled from 'styled-components';

const InactiveSection = styled.div`
  padding-left:6px;
  padding-top: 10px;
  padding-bottom: 10px;
  transition: background 0.3s;
  &:hover {
    background: #f4f4f4;
    cursor:pointer;
  }  
  position:relative;  
  color: ${props => props.isChildOpen ? '#2B5979;' :'#2196F3;'} 
`
const ActiveSection = styled(InactiveSection)`
  border-left: 4px solid #2B5979;    
  color: #2B5979;
`

const SectionWrapper = styled.div`  
  font-size:17px;
`

const SideNavWrapper = styled.div`
  margin-left:10px;
  background: #fafafa;
  max-width:220px
`

const Section = ({title, sectionId,activeSectionId, onClick}) => {
  return (
    <Fragment>
      <SectionWrapper onClick={() => onClick(sectionId)}>
      {activeSectionId === sectionId && <ActiveSection ><span>{title}</span></ActiveSection>}
      {activeSectionId !== sectionId && <InactiveSection ><span>{title}</span></InactiveSection>}      
      </SectionWrapper>
    </Fragment>
  )
}


class LoanNavigation extends React.Component {
  onClick =(sectionId)=> {
    this.props.selectSection(sectionId);
  }

  render(){    
    const {activeSectionId} = this.props;
    return (
    <SideNavWrapper>
      <Section title="Loan Terms" sectionId="loan_terms" activeSectionId={activeSectionId} onClick={this.onClick}/>      
      <Section title="Recourse" sectionId="loan_recourse" activeSectionId={activeSectionId} onClick={this.onClick}/>      
      <Section title="Fees" sectionId="loan_fees" activeSectionId={activeSectionId} onClick={this.onClick}/>
      <Section title="Reserves" sectionId="loan_reserves" activeSectionId={activeSectionId} onClick={this.onClick}/>
      <Section title="Hedge" sectionId="loan_hedge" activeSectionId={activeSectionId} onClick={this.onClick}/>
      <Section title="Covenants" sectionId="loan_covenants" activeSectionId={activeSectionId} onClick={this.onClick}/>
      <Section title="Other" sectionId="loan_other" activeSectionId={activeSectionId} onClick={this.onClick}/>
    </SideNavWrapper>
    )
  }
}

export default LoanNavigation;
